<template>
  <div class="forgot">
    <ui-title :title="t('forgot.title')" :wave="'/authTitleBg.png'" />
    <div class="container">
      <div class="forgot__wrapper">
        <forgot-password-form />
        <img class="forgot__wave" src="@images/authWave.png" alt="wave">
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import UiTitle from "@/components/ui/ui-title.vue";
import ForgotPasswordForm from "@/components/forms/forgot-password-form.vue";

const {t} = useI18n()
</script>

<style lang="scss" scoped>
.forgot {
  top: -103px;
  background-color: $white;
  position: relative;

  &__wrapper {
    padding-block: 100px;
  }

  &__wave {
    position: absolute;
    right: 0;
    bottom: 0;
  }
}
</style>